import { CHECKOUT } from "c7-logger/logger";

import { RumEvent, RumEventDomainContext } from "datadog-loader/loader";

import { TARGET } from "drop-in-ui/utils/configs";

const allowedDomains = [
  ...(TARGET === "c7-local" ? ["localhost"] : []),
  "jpmorgan.com",
  "jpmchase.com",
  "jpmchase.net",
  "fonts.googleapis.com",
  "kaptcha.com",
  "applepay.cdn-apple.com",
  "pay.google.com",
];
export const restrictedBeforeSend = (
  event: RumEvent,
  context: RumEventDomainContext
) => {
  let result = false;
  switch (event.type) {
    case "view": {
      result = true;
      break;
    }
    case "resource": {
      const url = event?.resource?.url;
      result = !!url && allowedDomains.some((domain) => url.includes(domain));
      break;
    }
    case "action": {
      if (event?.action?.type === "custom") {
        result = true;
        break;
      }
      const [...containers] = document.querySelectorAll(".checkout-experience");
      if ("events" in context) {
        const targets = context.events
          ? context.events.map(({ target }) => target)
          : [];
        result = targets.some((target) =>
          containers.some((container) => container.contains(target as Node))
        );
      }
      break;
    }
    case "error": {
      const fullPrefix = `console error: ${CHECKOUT}`;
      result = event.error.message.startsWith(fullPrefix);
      break;
    }
    default: {
      result = false;
      break;
    }
  }

  return result;
};
